export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVyrobcePneu';
export const NAME = 'VyrobcePneu';
